import IconMarkerHome from '../../../components/icons/IconMarkerHome';
import IconMarkerSkip from '../../../components/icons/IconMarkerSkip';
import IconMarkerImportant from '../../../components/icons/IconMarkerImportant';

// Frontend-owned marker-type registry - mirrors StudentElementNote.type's
// "frontend registry, no backend/schema change to add a kind" idiom. The
// backend only ever stores the free-string `code`; everything about how a
// type LOOKS (icon component, distinct shape not just color, accent color,
// tooltip label key) lives here. Add a new marker type by adding an entry
// here (+ the matching label key in language.jsx) - nothing else changes.
const BLOCK_MARKER_TYPES = {
   HOME_PRACTICE: { Icon: IconMarkerHome, color: '#4f8ff0', labelKey: 'blockMarkerHomePractice' },
   SKIP: { Icon: IconMarkerSkip, color: '#8a8f98', labelKey: 'blockMarkerSkip' },
   IMPORTANT: { Icon: IconMarkerImportant, color: '#e0533a', labelKey: 'blockMarkerImportant' },
};

export const BLOCK_MARKER_TYPE_LIST = Object.keys(BLOCK_MARKER_TYPES).map(code => ({ code, ...BLOCK_MARKER_TYPES[code] }));

export function getBlockMarkerType(code) {
   return BLOCK_MARKER_TYPES[code] || null;
}

export default BLOCK_MARKER_TYPES;
